module.exports = __webpack_public_path__ + "static/kghbanner-4995ce9acf857990b208e11dc2c79373.jpg";